/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v3.3.3
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var Constants = (function () {
    function Constants() {
    }
    Constants.STEP_EVERYTHING = 0;
    Constants.STEP_FILTER = 1;
    Constants.STEP_SORT = 2;
    Constants.STEP_MAP = 3;
    Constants.ROW_BUFFER_SIZE = 2;
    Constants.KEY_TAB = 9;
    Constants.KEY_ENTER = 13;
    Constants.KEY_BACKSPACE = 8;
    Constants.KEY_DELETE = 46;
    Constants.KEY_ESCAPE = 27;
    Constants.KEY_SPACE = 32;
    Constants.KEY_DOWN = 40;
    Constants.KEY_UP = 38;
    Constants.KEY_LEFT = 37;
    Constants.KEY_RIGHT = 39;
    return Constants;
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Constants;



/*****************
 ** WEBPACK FOOTER
 ** ../~/ag-grid/dist/lib/constants.js
 ** module id = 14
 ** module chunks = 0
 **/